// extracted by mini-css-extract-plugin
module.exports = {"stnBtn":"Button_stnBtn__MYf_i"};